import { render, staticRenderFns } from "./XmlPdfLoader.vue?vue&type=template&id=1f36aedd"
import script from "./XmlPdfLoader.vue?vue&type=script&lang=js"
export * from "./XmlPdfLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Inputs/XmlPdfLoader.vue
// module id = 1573
// module chunks = 31